// teacherAdminActions.js

import api from "lib/api/api";
import {
  FETCH_TEACHERS_FAILURE,
  FETCH_TEACHERS_REQUEST,
  FETCH_TEACHERS_SUCCESS,
  FETCH_TEACHER_INFORMATION_FAILURE,
  FETCH_TEACHER_INFORMATION_SUCCESS,
  UPDATE_TEACHER_PROFILE_ATTRIBUTES_FAILURE,
  UPDATE_TEACHER_PROFILE_ATTRIBUTES_REQUEST,
  UPDATE_TEACHER_PROFILE_ATTRIBUTES_SUCCESS,
  SAVE_ADMIN_TEACHER_FAILURE,
  SAVE_ADMIN_TEACHER_REQUEST,
  SAVE_ADMIN_TEACHER_SUCCESS,
  UPLOAD_TEACHER_PROFILE_PICTURE_FAILURE,
  UPLOAD_TEACHER_PROFILE_PICTURE_REQUEST,
  UPLOAD_TEACHER_PROFILE_PICTURE_SUCCESS,
} from "./types";

// Fetch all teacher details
export const fetchTeacherDetails = () => async (dispatch) => {
  dispatch({ type: FETCH_TEACHERS_REQUEST });

  try {
    const res = await api.get(`/admin/teacherDetails`);
    console.log("API Response:", res.data); // Log the API response to check the data

    dispatch({
      type: FETCH_TEACHERS_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    console.error("Error response:", error);
    dispatch({
      type: FETCH_TEACHERS_FAILURE,
      payload: error.response
        ? error.response.data.message
        : "Failed to fetch teacher data",
    });
  }
};

export const updateTeacherProfileAttributes =
  (teacherId, payload) => async (dispatch) => {
    dispatch({ type: UPDATE_TEACHER_PROFILE_ATTRIBUTES_REQUEST });

    try {
      const response = await api.put(
        `/admin/teachers/${teacherId}/profile-attributes`,
        payload,
        { withCredentials: true }
      );
      dispatch({
        type: UPDATE_TEACHER_PROFILE_ATTRIBUTES_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: UPDATE_TEACHER_PROFILE_ATTRIBUTES_FAILURE,
        payload:
          error.response?.data?.message ||
          error.message ||
          "Failed to update teacher profile attributes",
      });
    }
  };

export const createAdminTeacher = (payload) => async (dispatch) => {
  dispatch({ type: SAVE_ADMIN_TEACHER_REQUEST });

  try {
    const response = await api.post(`/admin/teachers`, payload);
    dispatch({
      type: SAVE_ADMIN_TEACHER_SUCCESS,
      payload: response.data,
    });
    dispatch(fetchTeacherDetails());
    return response.data;
  } catch (error) {
    const message =
      error.response?.data?.message ||
      error.response?.data ||
      error.message ||
      "Failed to create teacher";
    dispatch({ type: SAVE_ADMIN_TEACHER_FAILURE, payload: message });
    throw error;
  }
};

export const updateAdminTeacher = (teacherId, payload) => async (dispatch) => {
  dispatch({ type: SAVE_ADMIN_TEACHER_REQUEST });

  try {
    const response = await api.put(`/admin/teachers/${teacherId}`, payload);
    dispatch({
      type: SAVE_ADMIN_TEACHER_SUCCESS,
      payload: response.data,
    });
    return response.data;
  } catch (error) {
    const message =
      error.response?.data?.message ||
      error.response?.data ||
      error.message ||
      "Failed to update teacher";
    dispatch({ type: SAVE_ADMIN_TEACHER_FAILURE, payload: message });
    throw error;
  }
};

export const uploadTeacherProfilePicture =
  (teacherId, file) => async (dispatch) => {
    dispatch({ type: UPLOAD_TEACHER_PROFILE_PICTURE_REQUEST });

    const data = new FormData();
    data.append("file", file);

    try {
      const response = await api.post(
        `/admin/teachers/${teacherId}/profile-picture`,
        data,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      dispatch({
        type: UPLOAD_TEACHER_PROFILE_PICTURE_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.response?.data ||
        error.message ||
        "Failed to upload teacher profile picture";
      dispatch({
        type: UPLOAD_TEACHER_PROFILE_PICTURE_FAILURE,
        payload: message,
      });
      throw error;
    }
  };

// Action to fetch teacher information based on teacherId
export const fetchTeacherInformation = (teacherId) => async (dispatch) => {
  try {
    const response = await api.get(`/admin/${teacherId}/details`);
    dispatch({
      type: FETCH_TEACHER_INFORMATION_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_TEACHER_INFORMATION_FAILURE,
      payload: error.message,
    });
  }
};
